import { StylesConfig } from 'react-select';

import { LabelAndValue } from '@/types/custom';

export const selectStyles: StylesConfig<LabelAndValue, true> = {
  control: (styles, { isFocused, isDisabled }) => ({
    ...styles,
    backgroundColor: isDisabled ? '#f8f9fa' : 'white',
    borderColor: isDisabled ? '#dee2e6' : isFocused ? '#1a1a2e' : '#ced4da',
    boxShadow: isFocused ? '0 0 0 1px #1a1a2e' : 'none',
    '&:hover': {
      borderColor: isDisabled ? '#dee2e6' : isFocused ? '#1a1a2e' : '#adb5bd'
    },
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    borderRadius: 4,
    minHeight: 36
  }),
  valueContainer: (provided, { isDisabled }) => ({
    ...provided,
    padding: '0 6px',
    fontSize: '14px',
    fontWeight: 500,
    color: isDisabled ? '#6b7280' : '#1a1a2e',
    alignItems: 'center'
  }),
  indicatorsContainer: (provided, { isDisabled }) => ({
    ...provided,
    alignSelf: 'stretch',
    alignItems: 'center',
    opacity: isDisabled ? 0.5 : 1
  }),
  input: (provided, { isDisabled }) => ({
    ...provided,
    margin: '0px',
    color: isDisabled ? '#9ca3af' : '#1a1a2e'
  }),
  option: (styles, { isSelected, isFocused, isDisabled }) => ({
    ...styles,
    backgroundColor: isDisabled ? 'transparent' : isSelected || isFocused ? '#f1f3f5' : 'transparent',
    color: isDisabled ? '#9ca3af' : '#1a1a2e',
    fontWeight: isSelected ? 600 : 500,
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    padding: '8px 12px',
    fontSize: '14px',
    opacity: isDisabled ? 0.5 : 1,
    '&:hover': {
      backgroundColor: isDisabled ? 'transparent' : '#f1f3f5'
    }
  }),
  menu: (styles) => ({
    ...styles,
    borderRadius: 4,
    border: '1px solid #dee2e6',
    boxShadow: '0 4px 12px rgba(26, 26, 46, 0.08)',
    padding: 0,
    overflow: 'hidden'
  }),
  menuList: (styles) => ({
    ...styles,
    padding: 0,
    maxHeight: '200px'
  }),
  multiValue: (styles, { isDisabled }) => ({
    ...styles,
    backgroundColor: isDisabled ? '#f3f4f6' : '#f1f3f5',
    borderRadius: 4
  }),
  multiValueLabel: (styles, { isDisabled }) => ({
    ...styles,
    color: isDisabled ? '#6b7280' : '#1a1a2e',
    fontWeight: 500
  }),
  multiValueRemove: (styles, { isDisabled }) => ({
    ...styles,
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    '&:hover': {
      backgroundColor: isDisabled ? 'transparent' : '#e9ecef',
      color: isDisabled ? '#9ca3af' : '#1a1a2e'
    }
  }),
  singleValue: (styles, { isDisabled }) => ({
    ...styles,
    color: isDisabled ? '#6b7280' : '#1a1a2e',
    fontSize: '14px',
    fontWeight: 500
  }),
  placeholder: (styles, { isDisabled }) => ({
    ...styles,
    color: isDisabled ? '#d1d5db' : '#9ca3af'
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999
  }),
  indicatorSeparator: () => ({
    display: 'none'
  }),
  dropdownIndicator: (styles, { isDisabled }) => ({
    ...styles,
    padding: '0 8px',
    color: isDisabled ? '#d1d5db' : '#868e96',
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    '&:hover': {
      color: isDisabled ? '#d1d5db' : 'inherit'
    }
  }),
  clearIndicator: (styles) => ({
    ...styles,
    cursor: 'pointer'
  })
};
